import { render, staticRenderFns } from "./ContestTasksView.vue?vue&type=template&id=5356730c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ContestTasksView.vue?vue&type=script&lang=js&"
export * from "./ContestTasksView.vue?vue&type=script&lang=js&"
import style0 from "./ContestTasksView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VFlex,VIcon,VLayout,VTreeview})
